export default "__VITE_ASSET__L5QoKfnS__"